import { render, staticRenderFns } from "./view.html?vue&type=template&id=5b685826&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./homestyle.less?vue&type=style&index=0&id=5b685826&lang=less&scoped=true&"
import style1 from "./homestyle_mobile.less?vue&type=style&index=1&id=5b685826&lang=less&scoped=true&"
import style2 from "./otherstyle.less?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b685826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b685826')) {
      api.createRecord('5b685826', component.options)
    } else {
      api.reload('5b685826', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=5b685826&scoped=true&", function () {
      api.rerender('5b685826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/index.vue"
export default component.exports